export function initEventBridgeClientWrapper() {

	return {};
}